// The three image types the Featured Images tab manages, in the order every surface presents them.
// The key is the stable slug that appears in the composite bucket id, in the grid's `types` filter
// and in both write endpoints; the value is the MediaContent `categories` label the itinerary and
// document consumers read, and the only form that survives validateLabels.
export const FEATURED_IMAGE_TYPE_LABELS = {
  itineraryHeader: 'Itinerary Header',
  documentHeader: 'Document Header',
  documentDivider: 'Document Divider',
};
